export { default as Typing } from "./typing";
